// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { privacyChoicesStyles } from "@awc/App/Widgets/PrivacyChoices/PrivacyChoices";
import IconFooterPrivacy from "@awc/XDL/Icons/IconFooterPrivacy";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color, createLinkIconStyles } from "@awc/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

privacyChoicesStyles.privacyChoicesLink = {
    ...createLinkIconStyles({
        icon: IconFooterPrivacy,
        linkStyles: {
            typographyProps: {
                weight: fontConfig.weight.regular,
            },
            icon: {
                position: "right",
                iconProps: {
                    size: 14,
                    css: css`
                        margin-left: 10px;
                        &,
                        svg {
                            width: 29px;
                        }
                    `,
                },
            },
            css: css`
                &:hover ${TypographyStyle}, &:focus ${TypographyStyle} {
                    text-decoration: underline;
                    color: ${color("common.ui1")};
                }
            `,
        },

    }),
};
